/* oxlint-disable typescript/no-unnecessary-condition -- migration untrusted data */
// Migration: v1 → v2
// advanceLogics[].label was optional, now required — default missing label to ''

import type { MigratableTemplateContent } from './types';

export const migrateV1ToV2 = (data: MigratableTemplateContent): void => {
  const widgets = data.widgets;

  if (!widgets || typeof widgets !== 'object' || Array.isArray(widgets)) {
    data.version = '2';

    return;
  }

  for (const widget of Object.values(widgets)) {
    const advanceLogics = widget.advanceLogics;

    if (!Array.isArray(advanceLogics)) continue;
    for (const logic of advanceLogics) {
      if (typeof logic.label !== 'string') {
        logic.label = '';
      }
    }
  }

  data.version = '2';
};
